import script from "./CountryDetailetInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryDetailetInformation.vue?vue&type=script&setup=true&lang=js"

import "./CountryDetailetInformation.vue?vue&type=style&index=0&id=6871872a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6871872a"]])

export default __exports__